import {
  Users, TrendingUp, FileText, Globe, Settings,
  Database, Shield, Zap, Code, Building, Car,
  CreditCard, Wallet, BarChart, Layers, FolderOpen,
  Package, Wrench, UserCheck, ClipboardList, Truck,
  Book, GitPullRequest, HelpCircle, FileCode, Handshake, Star,
  Receipt, Hammer,
  LucideIcon
} from 'lucide-react';

export interface IconOption {
  value: string;
  label: string;
  icon: LucideIcon;
}

export const ICON_OPTIONS: IconOption[] = [
  { value: 'Users', label: 'Users', icon: Users },
  { value: 'UserCheck', label: 'User Check', icon: UserCheck },
  { value: 'TrendingUp', label: 'Trending Up', icon: TrendingUp },
  { value: 'FileText', label: 'File Text', icon: FileText },
  { value: 'FileCode', label: 'File Code', icon: FileCode },
  { value: 'Globe', label: 'Globe', icon: Globe },
  { value: 'Database', label: 'Database', icon: Database },
  { value: 'Settings', label: 'Settings', icon: Settings },
  { value: 'Shield', label: 'Shield', icon: Shield },
  { value: 'Zap', label: 'Zap', icon: Zap },
  { value: 'Code', label: 'Code', icon: Code },
  { value: 'Building', label: 'Building', icon: Building },
  { value: 'Car', label: 'Car', icon: Car },
  { value: 'CreditCard', label: 'Credit Card', icon: CreditCard },
  { value: 'Wallet', label: 'Wallet', icon: Wallet },
  { value: 'BarChart', label: 'Bar Chart', icon: BarChart },
  { value: 'Layers', label: 'Layers', icon: Layers },
  { value: 'FolderOpen', label: 'Folder', icon: FolderOpen },
  { value: 'Package', label: 'Package', icon: Package },
  { value: 'Wrench', label: 'Wrench', icon: Wrench },
  { value: 'ClipboardList', label: 'Clipboard', icon: ClipboardList },
  { value: 'Truck', label: 'Truck', icon: Truck },
  { value: 'Book', label: 'Book', icon: Book },
  { value: 'GitPullRequest', label: 'Git Pull Request', icon: GitPullRequest },
  { value: 'HelpCircle', label: 'Help Circle', icon: HelpCircle },
  { value: 'Handshake', label: 'Handshake', icon: Handshake },
  { value: 'Star', label: 'Star', icon: Star },
  { value: 'Tool', label: 'Tool', icon: Hammer },
  { value: 'Receipt', label: 'Receipt', icon: Receipt },
];

export const getIconComponent = (iconName: string | null): LucideIcon => {
  const found = ICON_OPTIONS.find(opt => opt.value === iconName);
  return found ? found.icon : Layers;
};
